import { createTheme as g } from "./ghl-ui.es855.js";
import n from "./ghl-ui.es1157.js";
import h from "./ghl-ui.es903.js";
import u from "./ghl-ui.es1081.js";
import { changeColor as x } from "./ghl-ui.es904.js";
const f = (e) => {
  const {
    iconColor: t,
    primaryColor: i,
    errorColor: o,
    textColor2: m,
    successColor: l,
    opacityDisabled: a,
    actionColor: d,
    borderColor: r,
    hoverColor: s,
    lineHeight: p,
    borderRadius: C,
    fontSize: c
  } = e;
  return {
    fontSize: c,
    lineHeight: p,
    borderRadius: C,
    draggerColor: d,
    draggerBorder: `1px dashed ${r}`,
    draggerBorderHover: `1px dashed ${i}`,
    itemColorHover: s,
    itemColorHoverError: x(o, {
      alpha: 0.06
    }),
    itemTextColor: m,
    itemTextColorError: o,
    itemTextColorSuccess: l,
    itemIconColor: t,
    itemDisabledOpacity: a,
    itemBorderImageCardError: `1px solid ${o}`,
    itemBorderImageCard: `1px solid ${r}`
  };
}, b = g({
  name: "Upload",
  common: n,
  peers: {
    Button: h,
    Progress: u
  },
  self: f
}), T = b;
export {
  T as default,
  f as self
};
